import { EntitlementType } from '@dreryk/drerykweb-medical-dictionaries-api';

import { formatAdditionalEntitlements } from '~libs.shared.prescription';

import { prescriptionTranslationKeys } from '../../../../../translations';
import { StyledPrescriptionTextView } from '../../prescriptionTextView.styled';

type EntitlementTypesTextViewProps = {
   readonly entitlementTypes: EntitlementType[];
};

export const EntitlementTypesTextView = (props: EntitlementTypesTextViewProps): JSX.Element => {
   return (
      <StyledPrescriptionTextView testId={'entitlementTypes'} compact label={prescriptionTranslationKeys.entitlements}>
         {formatAdditionalEntitlements(props.entitlementTypes) ?? '-'}
      </StyledPrescriptionTextView>
   );
};
